/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpmanagerolesdescription4Inputs */

const en_coinvestments_gpmanagerolesdescription4 = /** @type {(inputs: Coinvestments_Gpmanagerolesdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<bold>Investor Managers</bold> have full access (sign NDA, view sensitive data, submit offers).
<bold>Investor Viewers</bold> can only see the deal overview.`)
};

/**
* | output |
* | --- |
* | "<bold>Investor Managers</bold> have full access (sign NDA, view sensitive data, submit offers). <bold>Investor Viewers</bold> can only see the deal overview." |
*
* @param {Coinvestments_Gpmanagerolesdescription4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpmanagerolesdescription4 = /** @type {((inputs?: Coinvestments_Gpmanagerolesdescription4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpmanagerolesdescription4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpmanagerolesdescription4(inputs)
});
export { coinvestments_gpmanagerolesdescription4 as "coInvestments_gpManageRolesDescription" }